import {
  QueryFunction,
  QueryKey,
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { ExpensesApiService } from 'features/expenses-report/api/reports-api.service';
import {
  FieldsParams,
  FieldsResponse,
} from 'features/fields/api/fields-api.service';

import { ExpenseseQueryKeys } from './query-keys';

const { getDropDownReport } = ExpensesApiService();

const getFieldsQuery = (
  params: FieldsParams,
  options?: UseQueryOptions<FieldsResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<FieldsResponse>;
  options?: UseQueryOptions<FieldsResponse>;
} => ({
  queryKey: ExpenseseQueryKeys.list(params),
  queryFn: ({ signal }) => getDropDownReport(params, { config: { signal } }),
  ...options,
});

export const useGetExpensesDropDownFlag = (
  params: FieldsParams,
  options?: UseQueryOptions<any>,
) => {
  const { message } = App.useApp();

  return useQuery<any, Error>(
    getFieldsQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};

export const useGetFieldsInfiniteQuery = (
  params: FieldsParams,
  options?: UseInfiniteQueryOptions<any>,
) => {
  const { message } = App.useApp();

  return useInfiniteQuery({
    queryKey: ExpenseseQueryKeys.list(params),
    queryFn: ({ signal, pageParam }) =>
      getDropDownReport(
        { ...params, page: pageParam || params.page },
        { config: { signal } },
      ),
    getNextPageParam: (lastPage) => {
      const hasMorePages = lastPage.pages > lastPage.page;

      return hasMorePages ? lastPage.page + 1 : undefined;
    },
    onError: (error: unknown) => {
      const uiMessage = handleError(error);

      message.error(uiMessage);
    },
    ...options,
  });
};
